import React from "react";
import Title from "../../components/Title";
import {
  avatarContainer,
  avatarContent,
  container,
  projectSubtitle,
  tabContainer,
  tabText,
  titleContent,
} from "./TestCases.style";
import { Tab, Tabs } from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { SuiteTypes } from "../../interfaces/SuiteTypes";
import { ProjectsTypes } from "../../interfaces/ProjectsTypes";

import ExecutionsTab from "./Tabs/ExecutionsTab";
import TestCasesTab from "./Tabs/TestCasesTab";
import ConfigTab from "./Tabs/ConfigTab";
import { USER_DATA } from "../../utils/constants";
import HistoryTab from "./Tabs/HistoryTab";
import PyramidTab from "./Tabs/PyramidTab";
import KanbanTab from "./Tabs/KanbanTab";
import ScenarioGeneratorTab from "./Tabs/ScenarioGenerator";

interface Props {
  loading: boolean;
  currentProject: ProjectsTypes;
  reload: () => void;
  suites: SuiteTypes[];
}

export default function TestCasesScreen({
  loading,
  currentProject,
  reload,
  suites,
}: Props) {
  const [value, setValue] = React.useState(0);

  const userOwnerProject =
    JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid ===
    currentProject.main_user_uuid;

  const renderAvatar = (project: ProjectsTypes) => {
    var char1 = "";
    var char2 = "";

    try {
      char1 = project.title.split(" ")[0][0].toUpperCase();
      char2 = project.title.split(" ")[1]
        ? project.title.split(" ")[1][0].toUpperCase()
        : "";
    } catch (error) {}

    return (
      <div style={{ ...avatarContainer, backgroundColor: project.color }}>
        <span style={avatarContent}>{char1 + char2}</span>
      </div>
    );
  };

  const handleChangeTab = (newValue: number) => {
    setValue(newValue);
  };

  return (
    <div style={container}>
      <div style={titleContent}>
        <div style={titleContent}>
          {renderAvatar(currentProject)}
          <div>
            <Title text={currentProject.title} />
            <span style={projectSubtitle}>
              {currentProject.suitesSize} Suites de Testes |{" "}
              {currentProject.testCasesSize} Casos de Testes
            </span>
          </div>
        </div>
      </div>

      <Tabs
        value={value}
        onChange={(_, newValue) => handleChangeTab(newValue)}
        style={tabContainer}
      >
        <Tab label="Casos de Testes" style={tabText} />
        <Tab label="Execuções" style={tabText} />
        <Tab label="Pirâmide" style={tabText} />
        <Tab label="Gerador de cenários" style={tabText} />
        <Tab label="Kanban" style={tabText} />
        <Tab label="Histórico" style={tabText} />
        {userOwnerProject && <Tab label="Configurações" style={tabText} />}
      </Tabs>

      {/* TEST CASE TAB */}
      {value === 0 && (
        <TestCasesTab
          suites={suites}
          loading={loading}
          currentProject={currentProject}
          reload={reload}
        />
      )}

      {/* EXECUTIONS TAB */}
      {value === 1 && <ExecutionsTab currentProject={currentProject} />}

      {/* Piramide TAB */}
      {value === 2 && (
        <PyramidTab currentProject={currentProject} suites={suites} />
      )}

      {/* GERADOR CENÁRIOS TAB */}
      {value === 3 && <ScenarioGeneratorTab currentProject={currentProject} />}

      {/* KANBAN TAB */}
      {value === 4 && <KanbanTab currentProject={currentProject} />}

      {/* HISTORY TAB */}
      {value === 5 && <HistoryTab currentProject={currentProject} />}

      {/* CONFIG TAB */}
      {value === 6 && <ConfigTab currentProject={currentProject} />}
    </div>
  );
}
